export enum LanguagesEnum {
  English = 1,
  Spanish = 52,
  Arabic = 962,
  Hebrew = 972,
}
